import DescriptionIcon from './assets/description-icon.svg'

import styles from './APRLabel.pcss'

interface Props {
	children: string
	dataFor: string
}

export function APRLabel({ children, dataFor }: Props) {
	return (
		<div className={styles.container} data-tip data-for={dataFor}>
			<span>{children}</span>
			<DescriptionIcon className={styles.icon} />
		</div>
	)
}
